import { render, staticRenderFns } from "./courseAppointment.vue?vue&type=template&id=42c98db3&scoped=true&"
import script from "./courseAppointment.vue?vue&type=script&lang=js&"
export * from "./courseAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c98db3",
  null
  
)

export default component.exports